import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { Grid } from "@mui/material";
import { AiOutlineWarning } from "react-icons/ai";

import ConfirmationModal from "../../../../Dialogs/ConfirmationModal";
import { Color } from "../../../../Form/Button";
import useStyles from "./styles";

export interface CloseSSCCConfirmationModalHandles {
  open: () => void;
  close: () => void;
}
interface CloseSSCCConfirmationModalProps {
  closeModal?: () => void;
  onSubmit: () => void;
  loadingAction?: boolean;
  title: string;
  text?: string;
  warningText?: string;
}

const CloseSSCCConfirmationModal: ForwardRefRenderFunction<
  CloseSSCCConfirmationModalHandles,
  CloseSSCCConfirmationModalProps
> = (props, ref) => {
  const classes = useStyles();
  const { closeModal, onSubmit, title, text, warningText } = props;

  const [openModal, setOpenModal] = useState<boolean>(false);
  const open = useCallback(() => {
    setOpenModal(true);
  }, []);
  const close = useCallback(() => {
    setOpenModal(false);
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  return (
    <ConfirmationModal
      title={title}
      type="error"
      open={openModal}
      closeModal={() => {
        if (closeModal) closeModal();
        close();
      }}
      textSubmit="Close it"
      submit={onSubmit}
      className={classes.confirmModal}
      leftIconTitle={<AiOutlineWarning color="#F04438" size={20} />}
      customColorCancel={Color.TEXT_INFO}
      customColorSave={Color.ERROR}
    >
      <Grid container direction="column">
        <Grid item className={classes.confirmModalText}>
          <span>{text}</span>
        </Grid>
        <Grid item className={classes.confirmModalWarning}>
          <span>{warningText}</span>
        </Grid>
      </Grid>
    </ConfirmationModal>
  );
};

export default forwardRef(CloseSSCCConfirmationModal);
